var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(-226 -41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 24,
    height: 24,
    transform: "translate(226 41)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(-62.323 119.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M306.835-72.838l-1.423,5.974a.39.39,0,0,0,.161.413l2.362,1.586a.39.39,0,0,1,.172.322v4.927a.389.389,0,0,0,.767.09l1.527-6.4a.39.39,0,0,0-.177-.423l-2.432-1.466a.389.389,0,0,1-.188-.333l0-4.6A.389.389,0,0,0,306.835-72.838Z",
    transform: "translate(-1.494 0)",
    fill: "#ff673a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M300-72.838l-1.423,5.974a.389.389,0,0,0,.161.413l2.361,1.586a.388.388,0,0,1,.172.322v4.927a.389.389,0,0,0,.768.09l1.527-6.4a.389.389,0,0,0-.178-.423l-2.431-1.466a.389.389,0,0,1-.188-.333l0-4.6A.389.389,0,0,0,300-72.838Z",
    transform: "translate(-0.747 0)",
    fill: "#ff673a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M293.162-72.838l-1.423,5.974a.39.39,0,0,0,.161.413l2.362,1.586a.388.388,0,0,1,.172.322v4.927a.389.389,0,0,0,.767.09l1.527-6.4a.388.388,0,0,0-.177-.423l-2.432-1.466a.389.389,0,0,1-.188-.333v-4.6A.389.389,0,0,0,293.162-72.838Z",
    transform: "translate(0 0)",
    fill: "#ff673a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatIcon);
export default __webpack_public_path__ + "static/media/heat-icon.10612ad6eaac9e5e8435cb7556b31657.svg";
export { ForwardRef as ReactComponent };